import { render, staticRenderFns } from "./SellerQuotation.vue?vue&type=template&id=0863c8b0&scoped=true&"
import script from "./SellerQuotation.vue?vue&type=script&lang=js&"
export * from "./SellerQuotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0863c8b0",
  null
  
)

export default component.exports